import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { RedirectUrlService } from '../../helper/redirect-url.service';

@Injectable({
  providedIn: 'root',
})
export class LoginRedirectingGuard
  implements CanActivate, CanActivateChild, CanLoad
{
  constructor(
    private router: Router,
    private redirectUrlService: RedirectUrlService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canVisit();
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canVisit();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canVisit();
  }

  canVisit(): Observable<boolean> {
    let isAuthenticated: boolean = false;
    if (sessionStorage.getItem('presto-user')) {
      isAuthenticated = true;
    } else {
      //keep the requested page, logging in reloads the tab and would otherwise lose it
      this.redirectUrlService.rememberCurrentNavigation();
      this.router.navigate(['login']);
    }

    return of(isAuthenticated);
  }
}
